var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLockOverlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 410,
    height: 517.171,
    viewBox: "0 0 410 517.171",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6387",
    "data-name": "Group 6387",
    transform: "translate(-501.5 -272.721)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1610",
    "data-name": "Rectangle 1610",
    width: 410,
    height: 517.171,
    rx: 29,
    transform: "translate(501.5 272.721)",
    fill: "#1a5560",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "padlock_2_",
    "data-name": "padlock (2)",
    d: "M64.519,35.154H61.589V23.436a23.436,23.436,0,0,0-46.872,0V35.154H11.788A8.8,8.8,0,0,0,3,43.942V84.955a8.8,8.8,0,0,0,8.788,8.788H64.519a8.8,8.8,0,0,0,8.788-8.788V43.942A8.8,8.8,0,0,0,64.519,35.154ZM22.53,23.436a15.624,15.624,0,1,1,31.248,0V35.154H22.53Zm19.53,41.88v8.9a3.906,3.906,0,1,1-7.812,0v-8.9a7.812,7.812,0,1,1,7.812,0Z",
    transform: "translate(672.955 484.436)",
    fill: "#fff",
    opacity: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockOverlay);
export default __webpack_public_path__ + "static/media/lock-overlay.17f8fa26.svg";
export { ForwardRef as ReactComponent };